document.addEventListener('DOMContentLoaded', function () {
  const toggle = document.querySelector('.toggle-password');
  const input = document.getElementById('RegisterForm-password');

  if (!toggle || !input) return;

  function togglePassword() {
    const isHidden = input.type === 'password';
    input.type = isHidden ? 'text' : 'password';
    toggle.classList.toggle('is-visible', isHidden);
    toggle.setAttribute('aria-pressed', String(isHidden));
    toggle.setAttribute('aria-label', isHidden ? 'Masquer le mot de passe' : 'Afficher le mot de passe');
  }

  toggle.addEventListener('click', togglePassword);
  toggle.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      togglePassword();
    }
  });
});
